var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApiIconApiStatic(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "240px",
    height: "160px",
    viewBox: "0 0 240 160",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "API_icon_API_newStatic") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "API_icon_API_newStatic",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lv2_Icon_Frame_rest"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Frame_rest"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D9E8F6",
    x: 0,
    y: 0,
    width: 240,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#FFFFFF",
    x: 8,
    y: 8,
    width: 224,
    height: 144
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(47.499948, 29.512158)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hUzEZV",
    transform: "translate(0.000000, 8.487811)",
    fill: "#003A5D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8780682,80.4927411 C13.516839,80.4927411 1.77536714,70.0598067 0.707317584,57.2432121 C-0.445610078,43.9668611 9.25878718,32.7488042 23.3414803,30.8885589 L23.3414803,30.8249003 C25.2653841,24.9541644 27.9178251,18.3902572 35.4861232,14.1463517 C40.1905285,11.5137722 45.4865061,10.1191972 50.8773539,10.0934219 C55.9398996,10.0993218 60.9262245,11.3270981 65.4127302,13.6724489 C72.2595644,5.11390614 81.2707905,0.594146771 91.5834808,0.594146771 C93.4516606,0.597426917 95.3170237,0.739279623 97.1642166,1.01853732 C112.435203,3.30317312 122.02643,11.6283011 124.898139,25.1663597 C125.362634,27.2969646 125.630184,29.4657756 125.697408,31.6453887 C137.389368,35.0405131 144.915227,45.1480814 144.420104,56.8046752 C143.974494,67.414439 135.359366,77.1400558 123.907894,79.9198139 C122.387903,80.2607121 120.83241,80.4174488 119.274964,80.3866435 L118.12911,80.3866435 L117.004475,80.3866435 C109.294713,80.3866435 101.56609,80.3866435 93.8186044,80.3866435 L72.4929792,80.3866435 C68.0793175,80.3866435 63.6656558,80.3701394 59.2519941,80.3371312 L58.7073595,80.3371312 C54.2936978,80.3371312 49.8163775,80.287619 45.3178376,80.287619 C38.3578326,80.287619 32.6709992,80.3442044 27.4156296,80.4715216 L26.8780682,80.4927411 Z M50.9268661,18.2487937 C46.9164726,18.2596563 42.9759747,19.2995776 39.4824676,21.2690398 C34.955635,23.7800172 33.0670971,27.4297759 31.1714859,33.2934387 L31.0795347,33.5975853 C30.6763636,34.8990496 29.6012409,38.3790521 24.9541644,38.8883208 C15.0092791,39.984663 8.08463999,47.5741807 8.83439663,56.5712604 C9.54171421,65.1298032 17.8244031,72.3585889 26.8922146,72.3585889 L27.2953856,72.3585889 C32.6356333,72.2383449 38.3931985,72.1746863 45.4310085,72.1746863 C49.9719873,72.1746863 54.4917467,72.1746863 58.9549207,72.2241985 L59.3580917,72.2241985 C63.7528916,72.2524913 68.1476915,72.2689953 72.5424915,72.2737108 L93.8751898,72.2737108 C101.608529,72.2737108 109.337152,72.2737108 117.06106,72.2737108 L118.28472,72.2737108 L119.317403,72.2737108 C120.226745,72.3009749 121.136111,72.220248 122.02643,72.0332228 C129.997899,70.0951726 135.995952,63.5454118 136.293025,56.4722359 C136.625465,48.6351571 131.454973,41.8024692 123.426918,39.4966139 C119.656916,38.4073448 117.690573,35.9953919 117.584475,32.3173404 C117.546766,30.4732603 117.328818,28.6372866 116.933743,26.8356292 C114.776424,16.7139145 107.915444,10.899764 95.9688499,9.11025049 C94.4891081,8.88762198 92.9949942,8.77414498 91.4986027,8.77073805 C83.5271335,8.77073805 76.7510311,12.307326 71.3612711,19.3805018 C69.8546846,21.3539179 68.0793175,22.3512357 66.0988283,22.3512357 C64.7398899,22.2995786 63.4151488,21.9106638 62.2439474,21.2195275 C58.7647512,19.2927659 54.8544322,18.2780783 50.8773539,18.2700132 L50.9268661,18.2487937 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8780682,77.8898124 C14.9880596,77.8898124 4.24390551,68.4471226 3.28902677,57.0239437 C2.24926992,44.9853984 11.3170814,34.8212447 24.296359,33.3924632 C25.3290427,33.2792923 25.3856281,33.0812434 25.7109942,31.977828 L25.824165,31.6100228 C27.6419712,25.9514822 29.9902656,20.1868439 36.723929,16.4451338 C45.4332067,11.5172048 56.0794171,11.4770102 64.8256566,16.3390362 C66.1059014,17.0463538 66.1341941,16.9968416 66.891024,16.0065969 C74.4522489,6.10415075 84.7720125,1.86024525 96.7186065,3.62146603 C110.822519,5.74341879 119.671062,13.3753755 122.29521,25.7322137 C122.76375,27.8376864 123.024351,29.9840899 123.07326,32.140511 C123.108626,33.2014874 123.285455,33.6824634 124.919359,34.1563662 C135.451317,37.2049049 142.22742,46.2727164 141.788883,56.7127239 C141.385712,66.1978527 133.605219,74.9049322 123.285455,77.4088364 C121.600031,77.7590957 119.876377,77.8898556 118.157402,77.7978611 L117.025694,77.7978611 C105.416255,77.7978611 93.8115312,77.7978611 82.2115228,77.7978611 L72.4929792,77.7978611 C67.980293,77.7978611 63.4628914,77.781357 58.9407743,77.7483489 C48.5927181,77.6988367 37.891003,77.6351781 27.3802637,77.8898124 L26.8780682,77.8898124 Z M50.9268661,15.645865 C46.4660247,15.6558302 42.082349,16.8101981 38.1951496,18.9985503 C32.9185604,21.9268451 30.6975832,26.1707506 28.6463622,32.5366089 L28.5473377,32.8690482 C28.158313,34.1210003 27.5712394,36.0236846 24.6146519,36.3490507 C13.2409852,37.6010028 5.31902824,46.3929604 6.22439474,56.8046752 C7.07317584,66.8980971 16.6997682,75.1949324 27.3378246,74.9685908 C37.9758811,74.7422492 48.6139376,74.777615 58.9832134,74.8342004 C63.4958996,74.8342004 68.0085857,74.8837127 72.5212719,74.8837127 L82.2398155,74.8837127 C93.8398239,74.8837127 105.44219,74.8837127 117.046914,74.8837127 C117.435939,74.8837127 117.832036,74.8837127 118.221061,74.8837127 C119.692191,74.9707453 121.168408,74.8685274 122.613503,74.5795661 C131.688388,72.3798084 138.528149,64.8256566 138.881808,56.6278458 C139.263759,47.5671076 133.336438,39.6522238 124.134236,37.0210024 C121.467649,36.2500262 120.243989,34.7788056 120.166184,32.2678282 C120.12751,30.2781616 119.890566,28.2973072 119.458867,26.3546532 C117.08228,15.1719622 109.301786,8.50195737 96.336655,6.54976083 C85.3520129,4.90878404 76.2559088,8.67171359 69.2746842,17.8102568 C67.3578536,20.3212342 65.5683401,20.0807462 63.47468,18.9419649 C59.6153096,16.8145518 55.2841853,15.6886054 50.8773539,15.6670845 L50.9268661,15.645865 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 10,
    strokeLinejoin: "round",
    points: "14.3514738 99.4912914 37.1129537 99.4912914 37.1129537 63.071509"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 10,
    strokeLinejoin: "round",
    points: "126.850336 99.4912914 104.088856 99.4912914 104.088856 63.071509"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.272002,95.5868984 L70.272002,63.071509",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 10,
    strokeLinejoin: "round",
    points: "27.3590442 4.48439349 50.1134509 4.48439349 50.1134509 40.9041759"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 10,
    strokeLinejoin: "round",
    points: "114.493497 4.48439349 91.7320175 4.48439349 91.7320175 40.9041759"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#B4A269",
    strokeWidth: 4,
    strokeLinejoin: "round",
    points: "14.3514738 99.4912914 37.1129537 99.4912914 37.1129537 66.1059014"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3171023,66.2685845 C40.3171023,64.5067949 38.8888896,63.0785822 37.1271,63.0785822 C35.3653104,63.0785822 33.9370977,64.5067949 33.9370977,66.2685845 C33.9370977,68.0303741 35.3653104,69.4585868 37.1271,69.4585868 C38.8872759,69.4546969 40.3132124,68.0287603 40.3171023,66.2685845 Z",
    id: "Path",
    fill: "#B4A269",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#B4A269",
    strokeWidth: 4,
    strokeLinejoin: "round",
    cx: 9.44268975,
    cy: 99.7812916,
    r: 4.19439328
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#B4A269",
    strokeWidth: 4,
    strokeLinejoin: "round",
    points: "126.850336 99.4912914 104.088856 99.4912914 104.088856 66.1059014"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.278858,66.2685845 C107.278858,64.978349 106.501639,63.8151584 105.309617,63.3214066 C104.117595,62.8276549 102.745518,63.100578 101.833183,64.0129122 C100.920849,64.9252465 100.647926,66.2973234 101.141678,67.4893455 C101.63543,68.6813677 102.79862,69.4585868 104.088856,69.4585868 C105.849032,69.4546969 107.274968,68.0287603 107.278858,66.2685845 Z",
    id: "Path",
    fill: "#B4A269",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#B4A269",
    strokeWidth: 4,
    strokeLinejoin: "round",
    cx: 131.75912,
    cy: 99.7812916,
    r: 4.19439328
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.272002,95.5868984 L70.272002,69.1685866",
    id: "Path",
    stroke: "#B4A269",
    strokeWidth: 4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#B4A269",
    fillRule: "nonzero",
    points: "74.5088343 70.4063924 70.272002 63.071509 66.0422429 70.4063924"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#B4A269",
    strokeWidth: 4,
    strokeLinejoin: "round",
    cx: 69.9183432,
    cy: 99.7812916,
    r: 4.19439328
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#B4A269",
    strokeWidth: 4,
    strokeLinejoin: "round",
    points: "27.3590442 4.48439349 50.1134509 4.48439349 50.1134509 37.8697835"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9234486,37.7071004 C46.920588,39.0014796 47.6984801,40.1698649 48.8937854,40.6665247 C50.0890907,41.1631845 51.4659234,40.8901061 52.38119,39.9748395 C53.2964565,39.059573 53.5695349,37.6827402 53.0728751,36.4874349 C52.5762154,35.2921296 51.4078301,34.5142376 50.1134509,34.5170981 C48.353275,34.520988 46.9273385,35.9469246 46.9234486,37.7071004 Z",
    id: "Path",
    fill: "#B4A269",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#B4A269",
    strokeWidth: 4,
    strokeLinejoin: "round",
    cx: 22.4502601,
    cy: 4.19439328,
    r: 4.19439328
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#B4A269",
    strokeWidth: 4,
    strokeLinejoin: "round",
    points: "114.493497 4.48439349 91.7320175 4.48439349 91.7320175 37.8697835"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5420152,37.7071004 C88.5420152,39.4688901 89.9702279,40.8971027 91.7320175,40.8971027 C93.4938072,40.8971027 94.9220198,39.4688901 94.9220198,37.7071004 C94.9220198,35.9453108 93.4938072,34.5170981 91.7320175,34.5170981 C89.9718417,34.520988 88.5459051,35.9469246 88.5420152,37.7071004 Z",
    id: "Path",
    fill: "#B4A269",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#B4A269",
    strokeWidth: 4,
    strokeLinejoin: "round",
    cx: 119.402281,
    cy: 4.19439328,
    r: 4.19439328
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiIconApiStatic);
export default __webpack_public_path__ + "static/media/API_icon_API_Static.e7b43cf31029ff95a60798f339dcc504.svg";
export { ForwardRef as ReactComponent };